import React, { useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { animateScroll as scroll } from "react-scroll";
import { Icon } from "antd";

import { GlobalContext } from "../../../app/providers/GlobalState";
import MenuCanais from "./components/MenuCanais";
import PesquisaCanais from "./components/PesquisaCanais";

import { logo_stepforma } from "../../../assets/logos";
import styles from "./Navbar.module.scss";

const Navbar = () => {
    const [showNavbar, setShowNavbar] = useState(false);

    const context = useContext(GlobalContext);

    const handleShowNavbar = () => {
        setShowNavbar(!showNavbar);
    };

    return (
        <>
            <nav className={styles.navbar}>
                <div className={styles.containerMenu}>
                    <div className={styles.logo}>
                        <Link to="/">
                            <img src={logo_stepforma} alt="Logo" />
                        </Link>
                    </div>
                    <div className={`${styles.navElements} ${showNavbar ? styles.ativo : ""}`}>
                        <ul>
                            <li>
                                <NavLink
                                    to="#"
                                    onClick={
                                        !showNavbar
                                            ? () => scroll.scrollToTop()
                                            : () => {
                                                  scroll.scrollToTop();
                                                  handleShowNavbar();
                                              }
                                    }
                                >
                                    Home
                                </NavLink>
                            </li>
                            <li>
                                <NavLink
                                    to="#"
                                    onClick={
                                        !showNavbar
                                            ? () => scroll.scrollToBottom()
                                            : () => {
                                                  scroll.scrollToBottom();
                                                  handleShowNavbar();
                                              }
                                    }
                                >
                                    Contato
                                </NavLink>
                            </li>
                            <li>
                                <MenuCanais />
                            </li>
                        </ul>
                    </div>
                    <div className={styles.searchBlock}>
                        <Link to="#" onClick={() => context.atualizarState({ search_entidade: true })}>
                            <Icon type="search" />
                        </Link>
                    </div>
                    <div className={`${styles.searchBlock} ${styles.searchBlockMobile}`}>
                        <Link to="#" onClick={() => context.atualizarState({ search_entidade: true })}>
                            <Icon type="search" />
                        </Link>
                        <div className={styles.menuIcon} onClick={handleShowNavbar}>
                            <Icon type="menu" />
                        </div>
                    </div>
                </div>
            </nav>
            <PesquisaCanais />
        </>
    );
};

export default Navbar;
